module.exports = {"150124100":"城关镇","150124101":"宏河镇","150124102":"喇嘛湾镇","150124103":"老牛湾镇","150124200":"窑沟乡","150124201":"北堡乡","150124202":"韮菜庄乡","150124203":"五良太乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150124.json
// module id = 398
// module chunks = 0